// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__1umhE","footer":"ModalFilter_footer__1WM0a"};